import React, { useState } from "react";
import HEXBarChart from "@icons/hexpert/HEXBarChart";
import { FormGroup } from "../../components/FormGroup";
import { HexRadioItem } from "../../components/RadioItem";
import { RangeSlider } from "../../components/RangeSlider";
import { PageQuestion } from "../../types/hexpertTypes";
import './WeFitGraphRangeSliderBlock.scss';

const temporaryUnits = ["kW", "MMBtu/h", "Mcal/h"];
export const WeFitGraphRangeSliderBlock = ({
  Label,
  Max,
  Min,
  PredefinedValue,
  Step,
}: PageQuestion) => {
  // @TODO: should come from top level?
  const [value, setValue] = useState(0);
  const [tempUnit, setTempUnit] = useState(null);
  return (
    <FormGroup title={Label} titleUnit={tempUnit ?? temporaryUnits[0]}>
      <div className="c-hex-graph-range-slider-block-chart-container">
        <p className="c-hex-graph-range-slider-block-title">
          {value ? value : "-"} {tempUnit ?? temporaryUnits[0]}
        </p>
        <div className="c-hex-graph-range-slider-image-container">
          <HEXBarChart />
        </div>
      </div>
      <RangeSlider
        minValue={Min}
        maxValue={Max}
        interval={Step}
        name={Label}
        value={value}
        onChange={(val: number) => setValue(val)}
      />
      <div className="c-hex-graph-range-slider-block-units">
        {temporaryUnits.map((unit) => (
          <HexRadioItem
            key={unit}
            label={unit}
            name={Label + "unit"}
            onChange={() => {
              setTempUnit(unit);
            }}
            value={unit}
            selected={unit === tempUnit}
          />
        ))}
      </div>
    </FormGroup>
  );
};
